import { render, staticRenderFns } from "./PaletteModal.vue?vue&type=template&id=ade59392"
import script from "./PaletteModal.vue?vue&type=script&lang=js"
export * from "./PaletteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports